import React, { useRef } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import Avatar from "@arctheme-components/elements/Avatar/Avatar";
import { StarIcon } from "../TestimonialStar/TestimonialStar";
import { Image } from "@arctheme-components/elements/Image/Image";
import CarouselNavigation from "@project-stories/blocks/NavigationElements/CarouselNavigation";
import clsx from "clsx";

const CarouselLayout = ({ settings, blocks }) => {

  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const { section: {
    content_alignment_desktop,
    content_alignment_mobile,
    padding_left_right_mobile,
    padding_left_right_desktop,
    title,
    subtext,
    is_full_width_blocks
  }, globals } = settings;

  const carouselRef = useRef(null);
  const showAvatar = false;
  const paddingRight = `pr-[${padding_left_right_mobile}px] lg:pr-[${padding_left_right_desktop}px]`;
  const contentAlignment = isMobile
    ? content_alignment_mobile
    : content_alignment_desktop;
  
  // Check if there's only one testimonial
  const isSingleTestimonial = blocks.length === 1;

  return (
    <>
        {blocks.length > 0 && (
            <div className={"testimonials"}>
                <div className={`testimonials-top w-full ${paddingRight} text-${contentAlignment}`}>
                    <Headings text={title} type={isMobile ? "h4" : "h2"} />
                    <Paragraph text={subtext} type={isMobile ? "b3" : "b2"} />
                </div>

                <div
                    className={`testimonials__container ${!isSingleTestimonial ? 'carousel lg:px-[106px]' : ''} ${is_full_width_blocks ? paddingRight : ''}`}
                    {...(!isSingleTestimonial ? {
                    "x-data": "extended_carousel",
                    "x-init":
                        "$nextTick(() => { initialise(true, false, false, false, false, 'test') })",
                    "x-ref": "carousel"
                    } : {})}
                    ref={carouselRef}
                >
                    {blocks.map((blockItem, index) => (
                        <div
                            key={`carousel-item review-${index}`}
                            className={clsx('testimonial flex flex-col gap-8 lg:gap-9 ', {
                                'mx-3': !isSingleTestimonial,
                                'full-width-blocks': is_full_width_blocks,
                                'has-company-logo': blockItem.settings.company_logo
                            })}
                        >
                            {blockItem.settings.company_logo && (
                                <div className={`testimonial__company-logo`}>
                                    <Image
                                        imageUrl={blockItem.settings.company_logo}
                                        alt={"review_image"}
                                    />
                                </div>
                            )}

                            {(blockItem.settings.star_rating > 0) &&
                                <div className={"testimonial__ratings"}>
                                    {(() => {
                                        let rows: any = [];
                                        for (let i = 0; i < blockItem.settings.star_rating; i++) {
                                            // @ts-ignore
                                            rows.push(
                                                <React.Fragment key={`star-${i}`}>
                                                    <i className="icon rating-star"></i>
                                                </React.Fragment>
                                            );
                                        }
                                        return rows;
                                    })()}
                                </div>
                            }

                            <div className="lg:flex lg:justify-between w-full">
                                <div className={`testimonial__details gap-8 flex justify-start self-start`}>

                                    {(showAvatar || blockItem.settings.image || blockItem.settings.author || blockItem.settings.subtext) &&
                                        <div className={"testimonial-data flex self-left justify-start"}>
                                            {showAvatar && (
                                                <div className="testimonial__image">
                                                    <Avatar
                                                        imageUrl={"https://via.placeholder.com/150"}
                                                        size={"50px"}
                                                    />
                                                </div>
                                            )}

                                            {blockItem.settings.image && (
                                                <div
                                                    className={`testimonial__image flex`}
                                                >
                                                    <Image
                                                        imageUrl={blockItem.settings.image}
                                                        alt={"review_image"}
                                                    />
                                                </div>
                                            )}

                                        </div>
                                    }

                                    <div className={`gap-2 flex flex-col justify-center text-left`}>
                                        {blockItem.settings.author && (
                                            <p className="testimonial__author b_regular_normal">
                                                {blockItem.settings.author}
                                            </p>
                                        )}
                                        {blockItem.settings.subtext && (
                                            <p className="testimonial__subtext b_a2">
                                                {blockItem.settings.subtext}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                {!isSingleTestimonial && (
                                    <p className="testimonial__number b_a1 max-lg:hidden">
                                        {index + 1} / {blocks.length}
                                    </p>
                                )}
                            </div>

                            <div className="flex flex-col max-lg:justify-between">
                                <div
                                    className={`testimonial__quote b_large_normal`}
                                    dangerouslySetInnerHTML={{
                                        __html: blockItem.settings.blurb.replace(/\n/g, "<br />"),
                                    }}
                                />

                                {!isSingleTestimonial && (
                                    <p className="testimonial__number b_a1 lg:hidden mt-9">
                                        {index + 1} / {blocks.length}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                    
                {!isSingleTestimonial && (
                    <div
                        className={`section-bottomrow lg:absolute flex flex-row justify-center lg:justify-between items-center max-lg:mt-8 w-full`}
                    >
                        <CarouselNavigation
                            shiftPageDots={true}
                            carouselRef={carouselRef}
                            icons={globals.carousel_icons}
                            size={globals.carousel_icons?.carousel_navigation_arrow_size}
                        />
                    </div>
                )}
            </div>
        )}
    </>
  );
};

export default CarouselLayout;
